<!-- Account Overview — profile redesign (handoff panel 01).
     getDashboardData() feeds the stat counts, listCards() + the NgRx user
     drive the preserved bid-limit notice, and getMyRecentBids() fills the
     Recent-bidding table. -->

<div
    *ngIf="isLoading"
    class="vb-overview__loading"
    role="status"
    aria-label="Loading your account overview">
    <span class="vb-overview__spinner" aria-hidden="true"></span>
</div>

<section class="vb-overview" *ngIf="!isLoading">
    <!-- Greeting: 64px avatar + welcome + verification chip + meta line -->
    <header class="vb-overview__head" *ngIf="user">
        <vb-avatar [initials]="avatarInitials" size="lg"></vb-avatar>
        <div class="vb-overview__greeting">
            <div class="vb-overview__title-row">
                <h2 class="vb-overview__title">
                    Welcome, {{ user.firstname }} {{ user.lastname }}
                </h2>
                <vb-chip *ngIf="isVerified" tone="positive" icon="check">
                    Verified
                </vb-chip>
                <vb-chip *ngIf="isPendingVerification" tone="warn">
                    Pending verification
                </vb-chip>
            </div>
            <p class="vb-overview__meta">
                <span class="vb-overview__meta-item" *ngIf="user.createdOn">
                    <span class="vb-overview__eyebrow">Active since</span>
                    <span class="vb-overview__meta-value vb-num">
                        {{ user.createdOn | vbDate }}
                    </span>
                </span>
                <span class="vb-overview__meta-item">
                    <span class="vb-overview__eyebrow">Member</span>
                    <span class="vb-overview__meta-value">Buyer</span>
                </span>
            </p>
        </div>
    </header>

    <!-- Stat cards. The dashboard response carries no total-bids count, so
         the grid is the three counts it does return (invoices, watchlist,
         unread notifications). Invoices/watchlist navigate to their panels;
         Notifications opens the header bell dropdown (the unread updates the
         card is counting). -->
    <div class="vb-overview__stats">
        <vb-stat-card
            eyebrow="Invoices"
            icon="invoice"
            value="{{ invoiceCount }}"
            caption="Your purchases"
            (cardClick)="goTo('/profiles/my-profile/my-invoices')">
        </vb-stat-card>
        <vb-stat-card
            eyebrow="Watchlist"
            icon="eye"
            value="{{ watchListCount }}"
            [caption]="
                watchListCount > 0 ? 'Lots you follow' : 'Nothing saved yet'
            "
            (cardClick)="goTo('/profiles/watchlist')">
        </vb-stat-card>
        <!-- (click) stops the DOM bubble AFTER cardClick has opened the
             dropdown — the bell's document:click outside-close would
             otherwise re-close it on this same click. -->
        <vb-stat-card
            eyebrow="Notifications"
            icon="bell"
            value="{{ notificationsCount }}"
            caption="Unread updates"
            [valueTone]="notificationsCount > 0 ? 'red' : 'ink'"
            (click)="$event.stopPropagation()"
            (cardClick)="openNotificationsDropdown()">
        </vb-stat-card>
    </div>

    <!-- Bid limit / spending-cap notice — existing logic, restyled container -->
    <aside class="vb-overview__cap" *ngIf="user && showBidLimit">
        <span class="vb-overview__eyebrow">Bid limit</span>
        <p class="vb-overview__cap-line" *ngIf="hasSpendingCap">
            You currently have a bid limit of
            <strong class="vb-num">{{ spendingCapDisplay }}</strong>.
        </p>
        <p class="vb-overview__cap-line" *ngIf="spendingCapMessage">
            {{ spendingCapMessage }}
        </p>
    </aside>

    <!-- Recent bidding — the user's latest bid per lot (getMyRecentBids),
         rendered by the same vb-bid-table as the My-bidding ledger in its
         'recent' variant (bid-placed stamp in place of the closing countdown,
         no action column) so the two surfaces always agree — including the
         ≤720px card layout. Rows deep-link to the lot; "View all" is the
         full ledger. -->
    <section class="vb-overview__recent">
        <div class="vb-overview__recent-head">
            <span class="vb-overview__eyebrow">Recent bidding</span>
            <a
                class="vb-overview__recent-link"
                routerLink="/profiles/my-profile/my-bidding">
                View all &rarr;
            </a>
        </div>

        <vb-bid-table
            *ngIf="!recentBidsLoading"
            variant="recent"
            [rows]="recentBidRows"
            emptyLabel="Your latest bids will show up here."
            (rowClick)="onRecentBidClick($event)">
        </vb-bid-table>
    </section>
</section>
